import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=316682bb&scoped=true&"
var script = {}
import style0 from "./Terms.vue?vue&type=style&index=0&id=316682bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316682bb",
  null
  
)

export default component.exports